export default __webpack_public_path__ + "static/media/CAP_CapsuleCollection_Graphic.e93f2c82.gif";